import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link, useHistory } from 'react-router-dom';

export default function NavNegociacoes() {
  const { t } = useTranslation();
  const history = useHistory();

  function carregarNegociacao(filtro) {
    sessionStorage.setItem('negFiltro', filtro);
    history.push('/negociacoes');
  }

  return (
    <nav>
      <ul>
        <li><Link id="timeline" onClick={() => carregarNegociacao('all')} className="mnu" to="#">{t('pages.includes.navNegotiations.negotiations')}</Link></li>
        <li><Link id="classificados" onClick={() => carregarNegociacao('sent_received')} className="mnu" to="#">{t('pages.includes.navNegotiations.sendReceive')}</Link></li>
        {/* <li><Link id="classificados" className="mnu" to="/meus-anuncios">MEUS ANÚNCIOS</Link></li> */}
        {/* <li><Link id="BEZERRO" className="mnu" to="/timeline">#BEZERRO</Link></li>
        <li><Link id="BEZERRA" className="mnu" to="/timeline">#BEZERRA</Link></li>
        <li><Link id="BOI_GORDO_CEPEA" className="mnu" to="/timeline">#BOI_GORDO_CEPEA</Link></li>
        <li><Link id="NOVILHA_EU_HILTON" className="mnu" to="/timeline">#NOVILHA_EU_HILTON</Link></li>
        <li><Link id="NOVILHA_EUROPA" className="mnu" to="/timeline">#NOVILHA_EUROPA</Link></li>
        <li><Link id="NOVILHA_GORDA" className="mnu" to="/timeline">#NOVILHA_GORDA</Link></li>
        <li><Link id="NOVILHA_GORDA_CEPEA" className="mnu" to="/timeline">#NOVILHA_GORDA_CEPEA</Link></li> */}
      </ul>
    </nav>
  )
}